import { FC, useMemo } from 'react';

import dayjs from 'dayjs';
import useSWR from 'swr';

import Chip from '@mui/material/Chip';

import css from './StoreHistory.module.css';

import { storeService } from 'v2/api/storeService';
import { DataTable } from 'v2/components/dataTable/DataTable';
import { usePagination } from 'v2/hooks/usePagination';
import { TableColumn } from 'v2/types';
import { StoreHistoryModel } from 'v2/types/StoreModel';

export const StoreHistory: FC = () => {
  const { page, pageSize, onPageChange } = usePagination();

  const { data } = useSWR(['getStoreHistory', page, pageSize], storeService.getStoreHistory);

  const columns: TableColumn<StoreHistoryModel>[] = useMemo(
    () => [
      {
        id: 'userNickname',
        key: 'userNickname',
        label: 'User Nickname',
      },
      {
        id: 'value',
        key: 'value',
        label: 'Value',
        ellipsis: true,
      },
      {
        key: 'type',
        label: 'Type',
        render: (row) => <Chip label={row.type} color="info" variant="outlined" size="small" />,
      },
      {
        key: 'date',
        label: 'Purchase Date',
        align: 'right',
        render: (row) => dayjs(row.date).format('DD.MM.YYYY HH:mm'),
      },
    ],
    []
  );

  return (
    <DataTable
      containerClassName={css.storeHistoryTable}
      columns={columns}
      data={data?.result}
      total={data?.total}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
      withPagination
    />
  );
};
